import React, { useState, useEffect } from 'react';
import { animate } from 'animejs';
import './Contact.css';

const Contact = () => {
  useEffect(() => {
    // Fade in the entire page
    animate('.contact', {
      opacity: [0, 1],
      duration: 1000,
      easing: 'out-quad'
    });

    // Animate contact info items
    animate('.contact-item', {
      opacity: [0, 1],
      delay: (el, i) => i * 100 + 300,
      duration: 600,
      easing: 'out-quad'
    });

    // Animate form fields
    animate('.form-group', {
      opacity: [0, 1],
      delay: (el, i) => i * 80 + 400,
      duration: 600,
      easing: 'out-quad'
    });
  }, []);

  const [formData, setFormData] = useState({
    subject: '',
    cc: '',
    bcc: '',
    body: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(formData.subject);
    const body = encodeURIComponent(formData.body);
    const cc = formData.cc ? `&cc=${encodeURIComponent(formData.cc)}` : '';
    const bcc = formData.bcc ? `&bcc=${encodeURIComponent(formData.bcc)}` : '';
    window.location.href = `mailto:okgeorge.design@gmail.com?subject=${subject}${cc}${bcc}&body=${body}`;
  };

  return (
    <div className="contact">
      <div className="contact-container">
        <div className="contact-header">
          <h1 className="contact-title">Get In Touch</h1>
          <p className="contact-subtitle">
            Have a project in mind, or just a question? Feel free to contact me using the form below.
          </p>
        </div>

        <div className="contact-content">
          <div className="contact-form-wrapper">
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="subject">Subject</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    placeholder="Project inquiry"
                  />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="cc">CC</label>
                    <input
                      type="text"
                      id="cc"
                      name="cc"
                      value={formData.cc}
                      onChange={handleChange}
                      placeholder="email@example.com"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="bcc">BCC</label>
                    <input
                      type="text"
                      id="bcc"
                      name="bcc"
                      value={formData.bcc}
                      onChange={handleChange}
                      placeholder="email@example.com"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="body">Body</label>
                  <textarea
                    id="body"
                    name="body"
                    value={formData.body}
                    onChange={handleChange}
                    required
                    rows="6"
                    placeholder="Write your message..."
                  ></textarea>
                </div>

                <button type="submit" className="submit-button">
                  Send Message
                </button>
              </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
